import { render, staticRenderFns } from "./UpdateBaseInfo.vue?vue&type=template&id=7807814e&scoped=true&"
import script from "./UpdateBaseInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./UpdateBaseInfo.vue?vue&type=style&index=0&id=7807814e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7807814e",
  null
  
)

export default component.exports